import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';

const useLogoutCall = () =>
  useCallback(async () => {
    const result: undefined = await postFetcher({
      url: `${process.env.VITE_API_ROOT}/auth/sessiondestroy`,
      body: {},
    });

    return result;
  }, []);

export default useLogoutCall;
